import React, { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.fade-on-scroll');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "Message Sent",
      description: "Thank you for reaching out. We'll get back to you soon.",
    });
    setFormData({ name: '', email: '', company: '', message: '' });
  };

  return (
    <div className="w-full">
      {/* Hero */}
      <section className="min-h-[60vh] flex items-center justify-center bg-[#F5F1ED] relative overflow-hidden">
        <div className="absolute right-20 top-1/4 w-96 h-96 border border-[#A08872]/10 rounded-full"></div>
        <div className="container mx-auto px-6 py-20 relative z-10">
          <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-4 fade-on-scroll opacity-0">GET IN TOUCH</p>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif text-[#2A2A2A] mb-6 fade-on-scroll opacity-0">Contact Us</h1>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 max-w-5xl">
          <div className="grid md:grid-cols-2 gap-8 md:gap-16">
            <div className="fade-on-scroll opacity-0">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif text-[#2A2A2A] mb-8">Best-in-class businesses start here.</h2>
              <p className="text-lg text-[#3D3D3D] leading-relaxed mb-12">
                For investors and partners seeking asset-backed growth aligned with disciplined execution, UK Stage represents both stability and forward momentum.
              </p>
              
              <div className="space-y-8">
                <div>
                  <h3 className="text-sm text-[#8B7355] uppercase tracking-widest mb-2">ADDRESS</h3>
                  <p className="text-lg text-[#3D3D3D]">Dehradun, Uttarakhand<br />India</p>
                </div>
                
                <div>
                  <h3 className="text-sm text-[#8B7355] uppercase tracking-widest mb-2">EMAIL</h3>
                  <p className="text-lg text-[#3D3D3D]">info@ukstage.com</p>
                </div>
              </div>
            </div>
            
            <div className="fade-on-scroll opacity-0">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <Input 
                    placeholder="Name *"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                    className="border-[#EDE8E3] focus:border-[#8B7355]"
                  />
                </div>
                
                <div>
                  <Input 
                    type="email"
                    placeholder="Email *"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                    className="border-[#EDE8E3] focus:border-[#8B7355]"
                  />
                </div>
                
                <div>
                  <Input 
                    placeholder="Company"
                    value={formData.company}
                    onChange={(e) => setFormData({...formData, company: e.target.value})}
                    className="border-[#EDE8E3] focus:border-[#8B7355]"
                  />
                </div>
                
                <div>
                  <Textarea 
                    placeholder="Message *"
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    required
                    rows={6}
                    className="border-[#EDE8E3] focus:border-[#8B7355]"
                  />
                </div>
                
                <Button 
                  type="submit"
                  className="w-full bg-[#2A2A2A] hover:bg-[#8B7355] text-white transition-all duration-300"
                >
                  SEND MESSAGE
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;